/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/member-delimiter-style */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect, FC } from 'react'
import {
  Button,
  CssBaseline,
  Box,
  Typography,
  Container,
  Grid,
  Paper,
  Link,
  FormControl,
  TextField,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import API from '@aws-amplify/api'
import Auth from '@aws-amplify/auth'
import Spinner from '../../../components/Spinner'
import MemberShip from './MemberShip'
import MavCircleCheckBox from '../../../components/common/MavCircleCheckBox'
import LoadingButton from '../../../components/LoadingButton'

const Copyright: FC = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://maverickapp.io/">
        maverickapp.io
      </Link>
      {` ${new Date().getFullYear()}.`}
    </Typography>
  )
}

const useStyles = makeStyles(theme => ({
  tabRoot: {
    flexGrow: 1,
    display: 'flex',
    width: '100%',
    '& >div': {
      width: '100%',
    },
    '& .MuiBox-root': {
      padding: 0,
    },
  },
  root: {
    display: 'flex',
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  content: {
    flexGrow: 1,
    overflow: 'auto',
  },
  container: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
    fontFamily: 'Hind',
    boxShadow: 'none',
    background: 'transparent',
  },
  button: {
    width: '-webkit-fill-available',
    marginTop: 30,
  },
  twoButton: {
    width: 140,
    marginTop: 30,
  },
  buttonContainer: {
    width: 300,
  },
}))

const Billing: FC = () => {
  const classes = useStyles()
  const [licenseRecipient, setLicenseRecipient] = useState('user')
  const [isAuthenticated, userHasAuthenticated] = useState(false)
  const [userEmail, setUserEmail] = useState('')
  const [masterUserEmail, setMasterUserEmail] = useState('')
  const [licenseType, setLicenseType] = useState('personal')
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [clientType, setClientType] = useState('google')
  const [alertMessage, setAlertMessage] = useState('')
  const [isLoading, setIsLoading] = useState(true)
  const [action, setAction] = useState(0)
  const [activeStep, setActiveStep] = useState(0)
  const [skipped, setSkipped] = useState(new Set())
  const [billingTerms, setBillingTerms] = useState('Yearly')
  const [subscriptionData, setSubscriptionData] = useState<any>()

  const getSteps = (): string[] => {
    return [
      'Even a well-oiled machine needs maintenance.\nTake action today to keep your crew on pace to success.',
      'Who is this new Flight Plan for?',
      'Enter User Details',
      'Choose a Flight Plan below that fits your needs.',
    ]
  }

  const steps = getSteps()

  const isStepOptional = (step): boolean => {
    if (licenseRecipient === 'user') {
      return step === 2
    }
    return false
  }

  const isStepSkipped = (step): boolean => {
    return skipped.has(step)
  }

  const handleNext = (): void => {
    let newSkipped = skipped
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values())
      newSkipped.delete(activeStep)
    }
    if (activeStep === 0) {
      if (action === 0) {
        setActiveStep(prevActiveStep => prevActiveStep + 1)
      }
    } else if (activeStep === 2) {
      let newAlertMessage = ''
      if (!firstName || !lastName || !userEmail) {
        newAlertMessage += 'All fields are required.'
      }
      // if (!lastName) {
      //   newAlertMessage += 'Last Name is a required field. '
      // }
      // if (!userEmail) {
      //   newAlertMessage += 'Email is a required field.'
      // }
      setAlertMessage(newAlertMessage)
      if (userEmail && firstName && lastName) {
        setActiveStep(prevActiveStep => prevActiveStep + 1)
        setSkipped(newSkipped)
      }
    } else {
      setActiveStep(prevActiveStep => prevActiveStep + 1)
      setSkipped(newSkipped)
    }
  }

  const handleSkip = (): void => {
    if (!isStepOptional(activeStep)) {
      throw new Error("You can't skip a step that isn't optional.")
    }

    setActiveStep(prevActiveStep => prevActiveStep + 1)
    setSkipped(prevSkipped => {
      const newSkipped = new Set(prevSkipped.values())
      newSkipped.add(activeStep)
      return newSkipped
    })
  }

  const handleBack = (): void => {
    setActiveStep(activeStep - 1)
  }

  const handleReset = (): void => {
    setActiveStep(0)
    setFirstName('')
    setLastName('')
    setUserEmail(masterUserEmail)
    setLicenseType('personal')
  }

  const handleActionChange = (index: number): void => {
    setAction(index)
  }

  const handleTypeChange = (value: string): void => {
    setLicenseRecipient(value)
    if (value !== 'user') {
      setUserEmail('')
    }
  }

  const subscribeToProductPlan = async (token, productPlan): Promise<void> => {
    console.log('-0-0-0-0-0-0-0-0-000000000')
    setIsLoading(true)
    const bodyParams = {
      stripeToken: token.id,
      email: token.email,
      licenseRecipient: {
        email: userEmail,
        firstName,
        lastName,
        clientType,
        type: licenseType,
      },
      productPlan,
    }

    const myInit = {
      body: bodyParams,
    }
    try {
      await API.post('mav-outlook-api', '/users/billing', myInit)
      setIsLoading(false)
      window.location.reload()
    } catch (e) {
      console.error(e)
    }
  }

  const getStepContent = (step): JSX.Element | string => {
    switch (step) {
      case 0:
        return (
          <div>
            <FormControl component="fieldset">
              <MavCircleCheckBox
                title="Add a new Flight Plan"
                status={action === 0}
                handleClick={(): void => handleActionChange(0)}
              />
              <MavCircleCheckBox
                title="Manage my Flight Plan"
                status={action === 1}
                handleClick={(): void => handleActionChange(1)}
              />
            </FormControl>
          </div>
        )
      case 1:
        return (
          <div>
            <FormControl component="fieldset">
              <MavCircleCheckBox
                title="Add a new Flight Plan for me"
                status={licenseRecipient === 'user'}
                handleClick={(): void => handleTypeChange('user')}
              />
              <MavCircleCheckBox
                title="Add a new crew member to my account"
                status={licenseRecipient === 'other'}
                handleClick={(): void => handleTypeChange('other')}
              />
            </FormControl>
          </div>
        )
      case 2:
        if (licenseRecipient === 'user') {
          handleSkip()
          break
        } else {
          return (
            <div style={{ display: 'flex', flexDirection: 'column', width: '50%', margin: 'auto' }}>
              <FormControl style={{ marginTop: '10px' }}>
                <TextField
                  id="input-with-icon-adornment"
                  variant="outlined"
                  label="First Name"
                  onChange={(event): void => setFirstName(event.target.value)}
                />
              </FormControl>
              <br />
              <FormControl style={{ marginTop: '10px' }}>
                <TextField
                  id="input-with-icon-adornment"
                  variant="outlined"
                  label="Last Name"
                  onChange={(event): void => setLastName(event.target.value)}
                />
              </FormControl>
              <br />
              <FormControl style={{ marginTop: '10px' }}>
                <TextField
                  id="input-with-icon-adornment"
                  variant="outlined"
                  label="User Email"
                  onChange={(event): void => {
                    setUserEmail(event.target.value)
                    setLicenseType('team')
                  }}
                />
              </FormControl>
              <br />
              <h5>{alertMessage}</h5>
            </div>
          )
        }
      case 3:
        return (
          <MemberShip
            billingTerms={billingTerms}
            setBillingTerms={setBillingTerms}
            subscribeToProductPlan={subscribeToProductPlan}
          />
        )
      default:
        return 'Unknown step'
    }
    return 'Unknown step'
  }
  const onLoad = async (): Promise<void> => {
    let user
    let newSubscriptionData
    try {
      await Auth.currentSession()
    } catch (e) {
      if (e !== 'No current user') {
        console.error(e)
      }
    }
    try {
      user = await Auth.currentSession()
      setMasterUserEmail(user.idToken.payload.email)
      setUserEmail(user.idToken.payload.email)
      userHasAuthenticated(true)
    } catch (e) {
      console.error(e)
    }
    try {
      newSubscriptionData = await API.get('mav-outlook-api', '/users/billing', {})
      setSubscriptionData({ subscriptionData: newSubscriptionData })
    } catch (e) {
      console.error(e)
      setSubscriptionData(null)
    }
    setIsLoading(false)
  }

  useEffect(() => {
    onLoad()
  }, [isAuthenticated])

  const renderLander = (): JSX.Element => {
    return <Spinner />
  }
  const renderBilling = (data): JSX.Element => {
    return (
      <div className={`${classes.root} w-100 p-4 overflow-auto`}>
        <div className={classes.tabRoot}>
          <main className={classes.content}>
            <Grid container>
              <Grid item xs={12}>
                <Paper className={classes.paper}>
                  <div>
                    {!data || !data.subscriptionData?.subscriptions ? (
                      <h5>
                        It does not appear that you have any active subscriptions. Click below to
                        get started now.
                      </h5>
                    ) : (
                      <></>
                    )}
                    <div style={{ height: 'calc(100vh - 300px)' }}>
                      <>
                        <CssBaseline />
                        {activeStep === steps.length ? (
                          <div>
                            <Typography className={classes.instructions}>
                              All steps completed - you&apos;re finished
                            </Typography>
                            <LoadingButton
                              variant="primary"
                              onClick={handleReset}
                              className={classes.twoButton}
                            >
                              Back
                            </LoadingButton>
                          </div>
                        ) : (
                          <div>
                            <Typography
                              className="mb-8 text-inherit text-dark"
                              style={{ marginBottom: 50 }}
                            >
                              <pre>{steps[activeStep]}</pre>
                            </Typography>
                            {activeStep === 3 && (
                              <>
                                <Typography>
                                  Need help deciding which plan will work best to fill your sales
                                  funnel?
                                </Typography>
                                <Typography>
                                  Our expert Wingmen are happy to chat with you!
                                </Typography>
                                <Typography className=" mb-4">
                                  Simply click on SUPPORT from the drop down menu or email us at
                                  <a href="mailto:wingman@maverickapp.io">
                                    {' '}
                                    wingman@maverickapp.io.
                                  </a>
                                </Typography>
                              </>
                            )}
                            {getStepContent(activeStep)}
                            <div className={classes.buttonContainer}>
                              {isStepOptional(activeStep) && (
                                <LoadingButton variant="primary" onClick={handleSkip}>
                                  Skip
                                </LoadingButton>
                              )}
                              {/* eslint-disable-next-line no-nested-ternary */}
                              {activeStep === steps.length - 1 ? (
                                <div>
                                  <LoadingButton
                                    variant="primary"
                                    style={{ float: 'left', margin: '1em' }}
                                    onClick={handleReset}
                                    className={classes.twoButton}
                                  >
                                    Back
                                  </LoadingButton>
                                </div>
                              ) : activeStep !== 0 ? (
                                <div>
                                  <LoadingButton
                                    variant="primary"
                                    onClick={handleNext}
                                    style={{ float: 'right' }}
                                    className={classes.twoButton}
                                  >
                                    Next
                                  </LoadingButton>
                                  <LoadingButton
                                    variant="primary"
                                    style={{ float: 'left' }}
                                    onClick={handleBack}
                                    className={classes.twoButton}
                                  >
                                    Back
                                  </LoadingButton>
                                </div>
                              ) : (
                                <LoadingButton
                                  variant="primary"
                                  onClick={handleNext}
                                  className={classes.button}
                                >
                                  Next
                                </LoadingButton>
                              )}
                            </div>
                          </div>
                        )}
                      </>
                    </div>
                  </div>
                </Paper>
              </Grid>
            </Grid>
            <Box pt={4}>
              <Copyright />
            </Box>
          </main>
        </div>
      </div>
    )
  }

  const renderNotes = (): JSX.Element | null => {
    return !isLoading ? renderBilling(subscriptionData) : null
  }
  return isAuthenticated ? renderNotes() : renderLander()
}

export default Billing
